import type { IStageToolbarItemRenderArgs } from '../../types';
import { InlineScale } from './inline';
import { MenuScale } from './menu';

export const scaleItemRender = (args: IStageToolbarItemRenderArgs) => {
    const { active, config, pointerInsideToolbar, setActive, toolbar } = args;
    const itemConfig = config.items.scale;
    if (!itemConfig || !toolbar.getItemAvailability('scale')) return null;

    if (itemConfig.mode === 'inline') return <InlineScale toolbar={toolbar} />;

    return (
        <MenuScale
            active={active}
            pointerInsideToolbar={pointerInsideToolbar}
            setActive={setActive}
            showCanvasSize={itemConfig.showCanvasSize}
            toolbar={toolbar}
        />
    );
};
